module.exports = __webpack_public_path__ + "img/float-btn-poker.012a68d7.svg";